export const GPT_TAG = `<script async src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"></script>`;
